import React, { useState } from "react";
import { IoIosClose } from "react-icons/io";
import moment from "moment";
import DownloadPDF from "../../download-PDF/DownloadPDF";

const InvoiceComponent = ({ closeInvoice, data }) => {
  const [isDownload, setIsDownload] = useState(false);
  const handleDownloadPDF = () => {
    setIsDownload(true);
  };

  return (
    <div className="w-full h-full flex flex-col">
      <div className="cu-visit-header px-4 h-[63px] border-b w-full flex justify-between items-center text-lg text-[#454545] font-bold">
        <span>Consultation Receipt</span>
        <IoIosClose
          size={30}
          onClick={closeInvoice}
          className="cursor-pointer"
        />
      </div>
      <div className="w-full flex-1 overflow-auto">
        <div className="w-full px-4 my-4">
          <div className="font-bold text-sm">General Details</div>
          <div className="w-full flex flex-col gap-2 mt-2">
            <div className="flex w-full justify-between items-center tezt-sm">
              <div>Data</div>
              <div>{moment(data?.date_created).format("DD MMM yyyy")}</div>
            </div>
            <div className="flex w-full justify-between items-center tezt-sm">
              <div>Invoice No.</div>
              <div>{data?.invoice_no}</div>
            </div>
          </div>
        </div>
        <div className="w-full px-4 py-4 border-b ">
          <div className="font-bold text-sm">Invoice Details</div>
          <div className="w-full flex flex-col gap-2 mt-2">
            {data?.invoice_line_id?.map((item, i) => {
              return (
                <div className="flex w-full justify-between items-center tezt-sm">
                  <div>{item?.line_service?.name_of_service}</div>
                  <div>₹ {item?.line_service?.price}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="w-full px-4 py-4 border-b">
          <div className="font-bold text-sm">Total</div>
          <div className="w-full flex flex-col gap-2 mt-2">
            <div className="flex w-full justify-between items-center tezt-sm">
              <div>Amount</div>
              <div>₹ {data?.invoice_total}</div>
            </div>
            <div className="flex w-full justify-between items-center tezt-sm">
              <div>Discount</div>
              <div>
                {data?.discount}
                {data?.discount_type === "percentage" ? "%" : "₹ "}
              </div>
            </div>
            <div className="flex w-full justify-between items-center tezt-sm">
              <div>Total</div>
              <div>
                ₹{" "}
                {data?.discount_type === "percentage" ? (
                  <>
                    {data?.invoice_total -
                      data?.invoice_total * (data?.discount / 100)}
                  </>
                ) : (
                  <>{data?.invoice_total - data?.discount}</>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full px-4 my-4">
          <div className="font-bold text-sm">Payment</div>
          <div className="w-full flex flex-col gap-2 mt-2">
            <div className="flex w-full justify-between items-center tezt-sm">
              <div>Type</div>
              <div>
                {data?.payment_id?.reduce(
                  (acc, item) => acc + item?.received_payment,
                  0
                ) === data?.invoice_total
                  ? "Paid"
                  : "Partial"}
              </div>
            </div>

            {data?.payment_id?.map((item, i) => {
              return (
                <div className="flex w-full justify-between items-center tezt-sm">
                  <div>Payment {i + 1}</div>
                  <div>{item?.received_payment} ₹</div>
                </div>
              );
            })}
            {data?.payment_id?.reduce(
              (acc, item) => acc + item?.received_payment,
              0
            ) < data?.invoice_total && (
              <div className="flex w-full justify-between items-center tezt-sm">
                <div>Remaining Amount</div>
                <div>
                  ₹{" "}
                  {data?.invoice_total -
                    data?.payment_id?.reduce(
                      (acc, item) => acc + item?.received_payment,
                      0
                    )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {isDownload && (
        <DownloadPDF
          id={data?.id}
          type={"invoice"}
          close={() => setIsDownload(false)}
        />
      )}
      <div className="w-full py-2 px-4 text-center">
        <button
          onClick={handleDownloadPDF}
          className="h-[50px] border rounded-md bg-[#C7EAC9] text-xl w-full max-w-[328px]"
        >
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default InvoiceComponent;
